/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors } from '../../../../../../theme';

// ARROW
const ChartArrow = styled.img`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    cursor: pointer;
    background-color: white;
    border: none;
    padding: 8px;

    &.disabled {
        border: 1px solid ${colors.borderColorLight};
        background-color: ${colors.backgroundColorDisabled};
        cursor: auto;
    }

    :not(.disabled):hover, :not(.disabled):focus {
        outline: none;
        background-color: ${colors.backgroundColorHoverGreen};
    }

    :not(.disabled):active {
        background-color: ${colors.borderColorDown};
    }
`;

export const ChartArrowLeftStyled = styled(ChartArrow)`
    left: 16px;
`;

export const ChartArrowRightStyled = styled(ChartArrow)`
    right: 16px;
`;
